
import secondLevel from './secondLevel/reducer';
import firstLevel from './firstLevel/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('key', {
  secondLevel,
  firstLevel
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/emojis/reducer.js
 **/